export const ASSESSMENT = 'ASSESSMENT';
export const ASSESSMENT_REQUEST = 'ASSESSMENT_REQUEST';
export const ASSESSMENT_SUCCESS = 'ASSESSMENT_SUCCESS';
export const ASSESSMENT_ERROR = 'ASSESSMENT_ERROR';

export const ASSESSMENTFORDATA = 'ASSESSMENTFORDATA';
export const ASSESSMENTFORDATA_REQUEST = 'ASSESSMENTFORDATA_REQUEST';
export const ASSESSMENTFORDATA_SUCCESS = 'ASSESSMENTFORDATA_SUCCESS';
export const ASSESSMENTFORDATA_ERROR = 'ASSESSMENTFORDATA_ERROR';


export const ASSESSMENTFORDATASUBMIT = 'ASSESSMENTFORDATASUBMIT';
export const ASSESSMENTFORDATASUBMIT_REQUEST = 'ASSESSMENTFORDATASUBMIT_REQUEST';
export const ASSESSMENTFORDATASUBMIT_SUCCESS = 'ASSESSMENTFORDATASUBMIT_SUCCESS';
export const ASSESSMENTFORDATASUBMIT_ERROR = 'ASSESSMENTFORDATASUBMIT_ERROR';


export const TRANSAPPROVE = 'TRANSAPPROVE';
export const TRANSAPPROVE_REQUEST = 'TRANSAPPROVE_REQUEST';
export const TRANSAPPROVE_SUCCESS = 'TRANSAPPROVE_SUCCESS';
export const TRANSAPPROVE_ERROR = 'TRANSAPPROVE_ERROR';


export const SETFLAG = 'SETFLAG';



export const APPROVETRANSLATION = 'APPROVETRANSLATION';
export const APPROVETRANSLATION_REQUEST = 'APPROVETRANSLATION_REQUEST';
export const APPROVETRANSLATION_SUCCESS = 'APPROVETRANSLATION_SUCCESS';
export const APPROVETRANSLATION_ERROR = 'APPROVETRANSLATION_ERROR';


export const PLACEORDER = 'PLACEORDER';
export const PLACEORDER_REQUEST = 'PLACEORDER_REQUEST';
export const PLACEORDER_SUCCESS = 'PLACEORDER_SUCCESS';
export const PLACEORDER_ERROR = 'PLACEORDER_ERROR';

export const TRANSLATION = 'TRANSLATION';
export const TRANSLATION_REQUEST = 'TRANSLATION_REQUEST';
export const TRANSLATION_SUCCESS = 'TRANSLATION_SUCCESS';
export const TRANSLATION_ERROR = 'TRANSLATION_ERROR';

export const PDFREPORT = 'PDFREPORT';
export const PDFREPORT_REQUEST = 'PDFREPORT_REQUEST';
export const PDFREPORT_SUCCESS = 'PDFREPORT_SUCCESS';
export const PDFREPORT_ERROR = 'PDFREPORT_ERROR';

export const SELECT_FILE = 'SELECT_FILE';
export const FILTER_FILES = 'FILTER_FILES';
export const SEARCH_FILES = 'SEARCH_FILES';

export const EMAILVALIDATION = 'EMAILVALIDATION';
export const EMAILVALIDATION_REQUEST = 'EMAILVALIDATION_REQUEST';
export const EMAILVALIDATION_SUCCESS = 'EMAILVALIDATION_SUCCESS';
export const EMAILVALIDATION_ERROR = 'EMAILVALIDATION_ERROR';

export const UPDATEPASS = 'UPDATEPASS';
export const UPDATEPASS_REQUEST = 'UPDATEPASS_REQUEST';
export const UPDATEPASS_SUCCESS = 'UPDATEPASS_SUCCESS';
export const UPDATEPASS_ERROR = 'UPDATEPASS_ERROR';

export const USERINFO = 'USERINFO';
export const USERINFO_REQUEST = 'USERINFO_REQUEST';
export const USERINFO_SUCCESS = 'USERINFO_SUCCESS';
export const USERINFO_ERROR = 'USERINFO_ERROR';

export const APPROVE = 'APPROVE';
export const APPROVE_REQUEST = 'APPROVE_REQUEST';
export const APPROVE_SUCCESS = 'APPROVE_SUCCESS';
export const APPROVE_ERROR = 'APPROVE_ERROR';

export const SENDFINALAPPROVE = 'SENDFINALAPPROVE';
export const SENDFINALAPPROVE_REQUEST = 'SENDFINALAPPROVE_REQUEST';
export const SENDFINALAPPROVE_SUCCESS = 'SENDFINALAPPROVE_SUCCESS';
export const SENDFINALAPPROVE_ERROR = 'SENDFINALAPPROVE_ERROR';

export const REJECT = 'REJECT';
export const REJECT_REQUEST = 'REJECT_REQUEST';
export const REJECT_SUCCESS = 'REJECT_SUCCESS';
export const REJECT_ERROR = 'REJECT_ERROR';

export const FORGETPASSWORD = 'FORGETPASSWORD';
export const FORGETPASSWORD_REQUEST = 'FORGETPASSWORD_REQUEST';
export const FORGETPASSWORD_SUCCESS = 'FORGETPASSWORD_SUCCESS';
export const FORGETPASSWORD_ERROR = 'FORGETPASSWORD_ERROR';

export const CHANGEPASSWORD = 'CHANGEPASSWORD';
export const CHANGEPASSWORD_REQUEST = 'CHANGEPASSWORD_REQUEST';
export const CHANGEPASSWORD_SUCCESS = 'CHANGEPASSWORD_SUCCESS';
export const CHANGEPASSWORD_ERROR = 'CHANGEPASSWORD_ERROR';

export const SAVETRANSLATION = 'SAVE_TRANSLATION';
export const SAVEAPPROVETRANSLATION = 'SAVE_APPROVETRANSLATION';
export const SAVEORDERREQUEST = 'SAVE_SAVEORDERREQUEST';
export const SELECTROLE = "SELECTROLE";
export const CHANGEORDERCONFIRMED = "CHANGEORDERCONFIRMED";
export const CHANGEDS = "CHANGEDS";
export const CHANGESRC = "CHANGESRC";
export const CHANGEOPPNUM = "CHANGEOPPNUM";
export const CHANGEFINID = "CHANGEFINID";
export const CHANGECLIENTNAME = "CHANGECLIENTNAME";
export const SAVEAPPROVAL = 'SAVE_APPROVAL';
export const SAVEREJECTION = 'SAVE_REJECTION';
export const SAVEFINALAPPROVE = 'SAVE_FINALAPPROVE';
export const SETFLAGTRUE = 'SETFLAG_TRUE';
export const SETFLAGFALSE = 'SETFLAG_FALSE';

export const REFERENCEIDLIST = 'REFERENCEIDLIST';
export const REFERENCEIDLIST_REQUEST = 'REFERENCEIDLIST_REQUEST';
export const REFERENCEIDLIST_SUCCESS = 'REFERENCEIDLIST_SUCCESS';
export const REFERENCEIDLIST_ERROR = 'REFERENCEIDLIST_ERROR';

export const TRANSLATIONAPPROVEBYREFERENCEID =
  'TRANSLATIONAPPROVEBYREFERENCEID';
export const TRANSLATIONAPPROVEBYREFERENCEID_REQUEST =
  'TRANSLATIONAPPROVEBYREFERENCEID_REQUEST';
export const TRANSLATIONAPPROVEBYREFERENCEID_SUCCESS =
  'TRANSLATIONAPPROVEBYREFERENCEID_SUCCESS';
export const TRANSLATIONAPPROVEBYREFERENCEID_ERROR =
  'TRANSLATIONAPPROVEBYREFERENCEID_ERROR';


  export const TRANSLATIONAPPROVEBYREFERENCEIDFORQUOTE =
  'TRANSLATIONAPPROVEBYREFERENCEIDFORQUOTE';
export const TRANSLATIONAPPROVEBYREFERENCEIDFORQUOTE_REQUEST =
  'TRANSLATIONAPPROVEBYREFERENCEIDFORQUOTE_REQUEST';
export const TRANSLATIONAPPROVEBYREFERENCEIDFORQUOTE_SUCCESS =
  'TRANSLATIONAPPROVEBYREFERENCEIDFORQUOTE_SUCCESS';
export const TRANSLATIONAPPROVEBYREFERENCEIDFORQUOTE_ERROR =
  'TRANSLATIONAPPROVEBYREFERENCEIDFORQUOTE_ERROR';

export const DOWNLOADREPORT = 'DOWNLOADREPORT';
export const DOWNLOADREPORT_REQUEST = 'DOWNLOADREPORT_REQUEST';
export const DOWNLOADREPORT_SUCCESS = 'DOWNLOADREPORT_SUCCESS';
export const DOWNLOADREPORT_ERROR = 'DOWNLOADREPORT_ERROR';

export const DOWNLOADRPTBYREFERENCEID = 'DOWNLOADRPTBYREFERENCEID';
export const DOWNLOADRPTBYREFERENCEID_REQUEST =
  'DOWNLOADRPTBYREFERENCEID_REQUEST';
export const DOWNLOADRPTBYREFERENCEID_SUCCESS =
  'DOWNLOADRPTBYREFERENCEID_SUCCESS';
export const DOWNLOADRPTBYREFERENCEID_ERROR = 'DOWNLOADRPTBYREFERENCEID_ERROR';

export const TRANSDOWNLOADREPORT = 'TRANSDOWNLOADREPORT';
export const TRANSDOWNLOADREPORT_REQUEST =
  'TRANSDOWNLOADREPORT_REQUEST';
export const TRANSDOWNLOADREPORT_SUCCESS =
  'TRANSDOWNLOADREPORT_SUCCESS';
export const TRANSDOWNLOADREPORT_ERROR = 'TRANSDOWNLOADREPORT_ERROR';

export const DOWNLOADRPTBYUSERNAMEANDREFERENCEID = 'DOWNLOADRPTBYUSERNAMEANDREFERENCEID';
export const DOWNLOADRPTBYUSERNAMEANDREFERENCEID_REQUEST =
  'DOWNLOADRPTBYUSERNAMEANDREFERENCEID_REQUEST';
export const DOWNLOADRPTBYUSERNAMEANDREFERENCEID_SUCCESS =
  'DOWNLOADRPTBYUSERNAMEANDREFERENCEID_SUCCESS';
//export const DOWNLOADRPTBYUSERNAMEANDREFERENCEID_ERROR = 'DOWNLOADRPTBYUSERNAMEANDREFERENCEID_ERROR';


export const GETRPTLNKBYREFERENCEID = 'GETRPTLNKBYREFERENCEID';
export const GETRPTLNKBYREFERENCEID_REQUEST = 'GETRPTLNKBYREFERENCEID_REQUEST';
export const GETRPTLNKBYREFERENCEID_SUCCESS = 'GETRPTLNKBYREFERENCEID_SUCCESS';
export const GETRPTLNKBYREFERENCEID_ERROR = 'GETRPTLNKBYREFERENCEID_ERROR';

export const GETQUOTBYPO = 'GETQUOTBYPO';
export const GETQUOTBYPO_REQUEST = 'GETQUOTBYPO_REQUEST';
export const GETQUOTBYPO_SUCCESS = 'GETQUOTBYPO_SUCCESS';
export const GETQUOTBYPO_ERROR = 'GETQUOTBYPO_ERROR';

export const SAVEMEMBERNAME = 'SAVEMEMBERNAME';
export const SAVEMEMBERNAME_REQUEST = 'SAVEMEMBERNAME_REQUEST';
export const SAVEMEMBERNAME_SUCCESS = 'SAVEMEMBERNAME_SUCCESS';
export const SAVEMEMBERNAME_ERROR = 'SAVEMEMBERNAME_ERROR';


export const KEEPQUO = 'KEEPQUO';


export const HIDDENTEXT = 'HIDDENTEXT';
export const HIDDENTEXT_REQUEST = 'HIDDENTEXT_REQUEST';
export const HIDDENTEXT_SUCCESS = 'HIDDENTEXT_SUCCESS';


export const TRANSLATIONBYPONUMBER = 'TRANSLATIONBYPONUMBER';
export const TRANSLATIONBYPONUMBER_REQUEST = 'TRANSLATIONBYPONUMBER_REQUEST';
export const TRANSLATIONBYPONUMBER_SUCCESS = 'TRANSLATIONBYPONUMBER_SUCCESS';
export const TRANSLATIONBYPONUMBER_ERROR = 'TRANSLATIONBYPONUMBER_ERROR';

export const TRANSLATIONBYREPONAME = 'TRANSLATIONBYREPONAME';
export const TRANSLATIONBYREPONAME_REQUEST = 'TRANSLATIONBYREPONAME_REQUEST';
export const TRANSLATIONBYREPONAME_SUCCESS = 'TRANSLATIONBYREPONAME_SUCCESS';
export const TRANSLATIONBYREPONAME_ERROR = 'TRANSLATIONBYREPONAME_ERROR';

export const ACCESSMENTBYREPONAME = 'ACCESSMENTBYREPONAME';
export const ACCESSMENTBYREPONAME_REQUEST = 'ACCESSMENTBYREPONAME_REQUEST';
export const ACCESSMENTBYREPONAME_SUCCESS = 'ACCESSMENTBYREPONAME_SUCCESS';
export const ACCESSMENTBYREPONAME_ERROR = 'ACCESSMENTBYREPONAME_ERROR';

export const RESET_ASSESSMENT_STORE = 'RESET_ASSESSMENT_STORE';

export const CUSTOMERREGISTER = 'CUSTOMERREGISTER';

export const GENSOURCETEST = GENSOURCETEST;
export const GENSOURCETEST_SUCCESS = GENSOURCETEST_SUCCESS;

export const USERSLIST = 'USERSLIST';
export const USERSLIST_SUCCESS = 'USERSLIST_SUCCESS';

export const CHECKDFNAME = 'CHECKDFNAME';
export const CHECKDFNAME_SUCCESS = 'CHECKDFNAME_SUCCESS';

export const DFUSERSLIST = 'DFUSERSLIST';
export const DFUSERSLIST_SUCCESS = 'DFUSERSLIST_SUCCESS';

export const ADDUSERTODF = 'ADDUSERTODF';
export const ADDUSERTODF_SUCCESS = 'ADDUSERTODF_SUCCESS';

export const REMOVEUSERTODF = 'REMOVEUSERTODF';
export const REMOVEUSERTODF_SUCCESS = 'REMOVEUSERTODF_SUCCESS';

export const DELGETDFUSERSLIST = 'DELGETDFUSERSLIST';
export const DELGETDFUSERSLIST_SUCCESS = 'DELGETDFUSERSLIST_SUCCESS';

export const GETUSERLISTNOTINDF = 'GETUSERLISTNOTINDF';
export const GETUSERLISTNOTINDF_SUCCESS = 'GETUSERLISTNOTINDF_SUCCESS';

export const CHANGEOWNER = 'CHANGEOWNER';
export const CHANGEOWNER_SUCCESS = 'CHANGEOWNER_SUCCESS';


export const INSERTJDBCLIST = 'INSERTJDBCLIST';


export const REGISTER = 'REGISTER';

export const UNREGISTER = 'UNREGISTER';

export const customersList = 'customersList';
export const customersList_SUCCESS = 'customersList_SUCCESS';

export const alldfList = 'alldfList';
export const alldfList_SUCCESS = 'alldfList_SUCCESS';

export const checkddlexistjdbc = 'checkddlexistjdbc';
export const checkddlexistjdbc_SUCCESS = 'checkddlexistjdbc_SUCCESS';

export const checkexistunitest = 'checkexistunitest';
export const ccheckexistunitest_SUCCESS = 'checkexistunitest_SUCCESS';

export const checkddlexist = 'checkddlexist';
export const checkddlexist_SUCCESS = 'checkddlexist_SUCCESS';

export const customersPrjList = 'customersPrjList';
export const customersPrjList_SUCCESS = 'customersPrjList_SUCCESS';

export const CUSTOMERDFLIST = 'CUSTOMERDFLIST';
export const CUSTOMERDFLIST_SUCCESS = 'CUSTOMERDFLIST_SUCCESS';

export const stagingPrjList = 'stagingPrjList';
export const stagingPrjList_SUCCESS = 'stagingPrjList_SUCCESS';

export const userRequest = 'userRequest';
export const userRequest_SUCCESS = 'userRequest_SUCCESS';

export const RequestList = 'RequestList';
export const RequestList_SUCCESS = 'RequestList_SUCCESS';

export const NPRequestList = 'NPRequestList';
export const NPRequestList_SUCCESS = 'NPRequestList_SUCCESS';

export const downloadPrj = 'downloadPrj';
export const downloadPrj_SUCCESS = 'downloadPrj_SUCCESS';


export const checkfree = 'checkfree';
export const checkfree_ERROR = 'checkfree_ERROR';
export const checkfree_SUCCESS = 'checkfree_SUCCESS';

export const filesList = 'filesList';
export const filesList_ERROR = 'filesList_ERROR';
export const filesList_SUCCESS = 'filesList_SUCCESS';



// WEBPACK FOOTER //
// ./src/state/assessment/types.js